import React, { useEffect, useState } from 'react';
import { isWebpSupported } from 'react-image-webp/dist/utils';
import { imageProxy, nameFromSlug } from 'tf-post-parser';
import Head from '../Header/Head';
import PhotoHeader from './PhotoHeader';

const PhotoDetailHeader = props => {
  const {
    query,
    countrySlug,
    title,
    tag,
    setTopic,
    isMobileFullPage,
    locationDetails,
    noEdit,
  } = props;

  const [screenWidth, setScreenWidth] = useState(1920);
  const [webpSupport, setWebpSupport] = useState(undefined);

  useEffect(() => {
    setScreenWidth(Math.ceil(window.innerWidth / 100) * 100);
    setWebpSupport(isWebpSupported());
  }, []);

  const countryName = nameFromSlug(countrySlug);

  const detailTitle = (locationDetails && locationDetails.title) || title;
  let description = `${
    tag ? `Discover ${detailTitle}` : `Visit ${detailTitle}`
  }: ${
    locationDetails &&
    locationDetails.budgetScore &&
    locationDetails.budgetScore < 3
      ? `Traveling ${detailTitle} is affordable and exciting! `
      : ''
  }`;
  if (locationDetails && !locationDetails.url && locationDetails.description)
    description += `${locationDetails.description} `;
  description += `Explore the best places to visit, discover insider's tips, find out what to do${
    locationDetails &&
    locationDetails.budgetScore &&
    locationDetails.budgetScore > 4
      ? ` in ${detailTitle} on a budget`
      : ''
  } and read the top travel blogs about ${detailTitle} on TravelFeed!`;

  let image = '';
  if (locationDetails && locationDetails.unsplashUser) {
    image =
      webpSupport && locationDetails && locationDetails.image
        ? locationDetails.image.replace(/&fm=jpg/, '&fm=webp')
        : locationDetails.image;
  } else if (locationDetails && locationDetails.image) {
    image = imageProxy(
      locationDetails.image,
      screenWidth,
      500,
      undefined,
      webpSupport ? 'webp' : undefined,
    );
  }

  return (
    <>
      <Head
        noIndex={props.noIndex}
        shorttitle={`${title}: Top Travel Blogs`}
        description={description}
        feedUrl={props.feedUrl}
      />
      <div className="-tw-mt-[65px]">
        <PhotoHeader
          topMargin
          isMobileFullPage={isMobileFullPage}
          setTopic={setTopic}
          title={detailTitle}
          description={
            locationDetails ? locationDetails.description || description : ''
          }
          image={image}
          query={query}
          countrySlug={countrySlug}
          tag={tag}
          subtitle={
            (locationDetails && locationDetails.subtitle) || countryName
          }
          countryName={countryName}
          locationDetails={locationDetails || {}}
          noEdit={noEdit}
        />
      </div>
    </>
  );
};

export default PhotoDetailHeader;
